import React, { useState, useEffect, useMemo, useLayoutEffect } from "react";

import FilterForm from "app/Components/FilterForm/FilterForm";
import {
  useArea,
  useCategory,
  useContractorPerson,
  useEmployee,
  useTraining,
} from "app/_helpers/hooks";
import { getAllActivity } from "app/_services/_globalConfiguration/Activity/ActivityService";
import { getAllSites, getAllSitesData } from "app/_services/ehs/ehsSiteServices";
//import { UserService } from "app/_services/UserService/UserService";
//import { LOGGED_IN_USER_SITE_ID } from "../../IncidentManagement/Helper";
import { userDropdownLabel } from "app/_helpers/helper";
import moment from "moment";
import { LOGGED_IN_USER_SITE_ID } from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Helper";
import { UserService } from "app/_services/UserService/UserService";
// import { TRAINEE_TYPE, trainingStatusFilterFields } from "../../CONSTANTS";
import { employeeFilterFields } from "../Constant";

export default function EmployeeFilters({ form, onChange, onReset, setForm }) {
  const [state, setState] = useState({
    sites: [],
  });

  const [, trainingOption] = useTraining("filter[type]=training");

  const [nameList, setNameList] = useState([]);

  // useEffect(() => {
  //   setNameList(
  //     form?.traineeTypeView === TRAINEE_TYPE.employee
  //       ? [...employeesOption]
  //       : form?.traineeTypeView === TRAINEE_TYPE.contractorPerson
  //       ? [...contractorPersonsOption]
  //       : [...employeesOption, ...contractorPersonsOption]
  //   );
  // }, [contractorPersonsOption, employeesOption, form?.traineeTypeView]);

  useEffect(() => {
    // getAllSites("filter[status]=1").then((response) => {
    getAllSitesData("filter[status]=1").then((response) => {
      if (!response?.data) return;

      setState((prev) => ({
        ...prev,
        //initialActivity: response?.data,
        sites: response.data.map((row) => ({ label: row.name, value: row.id })),
      }));
    });
  }, []);

  const fields = useMemo(
    () =>
      employeeFilterFields.map((f) => {
        const field = { ...f };

        switch (field.name) {
          case "currentWorkLocation":
            field.options = state.sites;
            break;
          case "trainingDesignation":
            field.options = trainingOption;
            break;

          default:
            break;
        }

        return field;
      }),
    [state.sites, trainingOption]
  );

  const handleDateRange = (dates, name) => {
    //console.log("dates", dates, name);
    onChange({
      target: {
        name: "startDate",
        value: dates.startDate
          ? moment(new Date(dates.startDate)).format("YYYY-MM-DD")
          : null,
        key: name,
      },
    });
    onChange({
      target: {
        name: "endDate",
        value: dates.endDate
          ? moment(new Date(dates.endDate)).format("YYYY-MM-DD")
          : null,
        key: name,
      },
    });
  };

  return (
    <div className="pb-4">
      <FilterForm
        fields={fields}
        form={form}
        onChange={onChange}
        onReset={onReset}
        handleDateRange={handleDateRange}
        multiFieldDateRange
      />
    </div>
  );
}
